import {Routes} from "@angular/router";

export const CustomersRoutes: Routes = [
    {
        path: "",
        loadComponent: () =>
            import("@/app/domains/auth/customer/pages/customers/customers.page").then((m) => m.CustomersPage),
    },
    {
        path: "natural-person-edit",
        loadComponent: () =>
            import("@/app/domains/shared/persons/pages/natural-person-edit/natural-person-edit.page").then(
                (m) => m.NaturalPersonEditPage
            ),
    },
    {
        path: "company-container",
        children: [
            {
                path: "",
                loadComponent: () =>
                    import("@/app/domains/auth/company/pages/company-container/company-container.page").then(
                        (m) => m.CompanyContainerPage
                    ),
            },
            // company-container y branch-edit navegan relativo a la ruta actual: sin estas hijas, «Datos de la empresa» y
            // «Direcciones» de una sucursal caían en "**" y volvían a la lista de clientes (igual que en providers.routes.ts).
            {
                path: "company-edit",
                loadComponent: () =>
                    import("@/app/domains/auth/company/pages/company-edit/company-edit.page").then(
                        (m) => m.CompanyEditPage
                    ),
            },
            {
                path: "branch-edit",
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("@/app/domains/auth/company/pages/branch-edit/branch-edit.page").then(
                                (m) => m.BranchEditPage
                            ),
                    },
                    {
                        path: "address-container",
                        children: [
                            {
                                path: "",
                                loadComponent: () =>
                                    import("@/app/domains/shared/addresses/pages/address-container/address-container.page").then(
                                        (m) => m.AddressContainerPage
                                    ),
                            },
                            {
                                path: "address-edit",
                                loadComponent: () =>
                                    import("@/app/domains/shared/addresses/pages/address-edit/address-edit.page").then(
                                        (m) => m.AddressEditPage
                                    ),
                            },
                        ],
                    },
                ],
            },
        ]
    },
    {
        path: "natural-person-edit/address-container",
        children: [
            {
                path: "",
                loadComponent: () =>
                    import("@/app/domains/shared/addresses/pages/address-container/address-container.page").then(
                        (m) => m.AddressContainerPage
                    ),
            },
            {
                path: "address-edit",
                loadComponent: () =>
                    import("@/app/domains/shared/addresses/pages/address-edit/address-edit.page").then(
                        (m) => m.AddressEditPage
                    ),
            },
        ],
    },
    {
        path: "**",
        redirectTo: "",
        pathMatch: "full",
    },
];
